var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Gallery',{attrs:{"images":[
    require('@/assets/img/automotive/IMG_1889-1200w.jpg'),
    require('@/assets/img/automotive/IMG_2035-1200w.jpg'),
    require('@/assets/img/automotive/IMG_9480-1200w.jpg'),
    require('@/assets/img/automotive/IMG_2221-1200w.jpg'),
    require('@/assets/img/automotive/IMG_2051-1200w.jpg') ]}})}
var staticRenderFns = []

export { render, staticRenderFns }